import { IconVariant } from "@/components/atoms";
import { QuickSetupModal } from "./QuickSetupModal";

interface DownloadModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  imageUrl: string;
  downloadImageUrl?: string;
  enableDownload?: boolean;
  featuredIcon?: {
    name: string;
    background?: string;
    className?: string;
    isCustom?: boolean;
    variant?: IconVariant;
  };
}

export const DownloadModal = ({
  open,
  onClose,
  title,
  subtitle,
  imageUrl,
  enableDownload = true,
  featuredIcon,
  downloadImageUrl,
}: DownloadModalProps) => {
  return (
    <QuickSetupModal
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      variant="web-large"
      content={{
        type: "image",
        imageUrl,
        downloadImageUrl,
        enableDownload,
      }}
      featuredIcon={featuredIcon}
    />
  );
};
